var win_H=$(window).height();
$("body ,.list ").height(win_H);
var listNmu=$(".list").length-1;
var old_case = 0;
window.chage_nav=function(num){
    if(!$(".main").is(":animated")){
        var case_num=0-(num*win_H)+"px";
        $(".main").animate({top:case_num},400);
        for(var t=0;t<$(".menu li").length;t++){
            $(".menu li").eq(t).removeClass("current");
        }
        $(".menu li").eq(num).addClass("current");
        setTimeout(function(){
            $(".list").removeClass("animation").eq(num).addClass("animation");
        },600);
        old_case=num;
    }
};

function M_scroll(Direction){
    if(Direction){
        if(old_case!=0){
            chage_nav(old_case-1);
        }
        old_case-1;
    }else{
        if(old_case!=listNmu){
            chage_nav(old_case+1);
        }
        old_case+1;
    }
}
$(function(){

    var url=window.location.search;
    if(url.indexOf('participate')>0){
        chage_nav(2);
    }else{
        chage_nav(0)
    }
    $(window).resize(function(){
        win_H=$(window).height();
        $("body ,.list ").height(win_H);
        chage_nav(0)
    });
    var scrollFunc=function(e){
        e=e || window.event;
        if(e.detail){
            if(e.detail>0){//Firefox
                M_scroll(false)
                //向下
            }else{
                M_scroll(true)
                //向上
            }
        }else{
            if(e.wheelDelta>0){//IE/Opera/Chrome
                M_scroll(true)
                //向上
            }else{
                M_scroll(false)
                //向下
            }
        }
    };
    /*注册事件*/
    if(document.addEventListener){
        document.addEventListener('DOMMouseScroll',scrollFunc,false);
    }//W3C
    document.onmousewheel=scrollFunc;
//IE/Opera/Chrome
});
